<template>
  <div class="app">
    <div class="header">
      <img style="width: 50%" src="../src/assets/logo.png" alt="" />
    </div>

    <div class="body">
      <h1>Odaberi sliku ili video iz galerije i pošalji</h1>
      <div class="buttons">
        <label for="file-upload">
          <img
            src="../src/assets/odaberi.png"
            alt="Odaberi"
            style="cursor: pointer; pointer-events: none"
          />
        </label>
        <input
          type="file"
          id="file-upload"
          accept="image/*,video/*"
          @change="selectImages"
          class="file-input"
          multiple 
          />
      </div>
    </div>

    <div class="body2">
      <h1>Snimi govornu poruku i pošalji</h1>
      <div class="buttons">
        <div 
          class="record-button-container"
          @mousedown="startRecording"
          @mouseup="stopRecording"
          @mouseleave="stopRecording"
          @touchstart.prevent="startRecording"
          @touchend.prevent="stopRecording"
          @touchcancel.prevent="stopRecording"
        >
          <img
            :src="isAudioRecording ? require('../src/assets/posaljizvuk.png') : require('../src/assets/drzizasnimanje.png')"
            alt="Record Voice"
            :class="{ 'recording': isAudioRecording }"
            style="cursor: pointer; width: 120px;"
          />
        </div>
      </div>
      
      <!-- Audio preview section -->
      <div v-if="audioUrl" class="preview-container">
        <!-- <audio controls :src="audioUrl" class="audio-preview"></audio> -->
        <div class="preview-controls">
          <button @click="uploadAudio" class="preview-button accept">Pošalji</button>
          <button @click="discardAudio" class="preview-button cancel">Odbaci</button>
        </div>
      </div>
      
      <div v-if="videoUrl" class="preview-container">
        <video controls :src="videoUrl" class="video-preview"></video>
        <div class="preview-controls">
          <button @click="uploadVideo" class="preview-button accept">Pošalji</button>
          <button @click="discardVideo" class="preview-button cancel">Odbaci</button>
        </div>
      </div>
    </div>

    <div v-if="uploadStatus" class="status-message" :class="{ success: uploadSuccess, error: !uploadSuccess }">
      <img class="logo" src="../src/assets/logo.png" alt="Logo" />

      <div v-if="!uploadSuccess" class="loader-container">
        <div class="loader"></div>
      </div>

      <p class="upload-status">{{ uploadStatus }}</p>

      <div class="upload-info" v-if="!uploadSuccess">
        <p>Ne izlazite iz aplikacije</p>
        <p>Slanje traje ovisno o veličini datoteke ili brzini interneta</p>
      </div>
      <div v-if="uploadSuccess" class="button" @click="uploadStatus = ''" >OK</div>
    </div>

    <div v-if="permissionError" class="error-message">
      {{ permissionError }}
      <button @click="requestPermissions" class="permission-button">Dopusti pristup</button>
    </div>

    <div class="footer">
      © Weddings Record Team. Profesionalno fotografiranje i snimanje vjenčanja.
      099 87 309 37
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      selectedImage: null,
      imageFile: null,

      mediaRecorder: null,
      audioStream: null,
      audioChunks: [],
      audioBlob: null,
      audioUrl: null,
      isAudioRecording: false,

      videoStream: null,
      videoChunks: [],
      videoBlob: null,
      videoUrl: null,
      videoFile: null,
      isVideoRecording: false,
      videoPreviewRef: null,

      isUploading: false,
      uploadStatus: "",
      uploadSuccess: false,
      
      permissionError: null,
    };
  },
  watch: {
    // Removed automatic upload on selection to allow preview
  },
  methods: {
    setupMediaDevices() {
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          const getUserMedia =
            navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }

          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
    },
    
    // Request permissions explicitly for camera and microphone
    async requestPermissions() {
      try {
        this.permissionError = "Traženje dopuštenja...";
        
        // Request camera permission
        await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: { ideal: "environment" },
            width: { ideal: 720 },
            height: { ideal: 1280 },
            aspectRatio: { ideal: 9 / 16 },
          }
        });
        
        // Request microphone permission
        await navigator.mediaDevices.getUserMedia({ audio: true });
        
        this.permissionError = null;
        alert("Dopuštenja odobrena! Možete snimati audio i video.");
      } catch (error) {
        console.error("Permission error:", error);
        this.permissionError = "Nije moguće dobiti dopuštenja. Molimo omogućite pristup kameri i mikrofonu u postavkama preglednika.";
      }
    },

    selectImage(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      // Check if the file is an image
      if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
        alert("Molimo odaberite sliku ili video.");
        return;
      }
      
      this.imageFile = file;
      this.selectedImage = URL.createObjectURL(file);
      this.uploadImage()
    },
        
    async selectImages(event) {
      const files = Array.from(event.target.files);
      if (!files.length) return;

      // Validate files (images/videos only)
      const validFiles = files.filter(file =>
        file.type.startsWith('image/') || file.type.startsWith('video/')
      );

      if (!validFiles.length) {
        alert("Molimo odaberite sliku ili video.");
        return;
      }

      // Upload either single or multiple files
      await this.uploadFiles(validFiles);
    },

    async uploadFiles(files) {
      this.isUploading = true;
      this.uploadStatus = "Slanje datoteka u tijeku...";
      const uploadPromises = files.map(file => {
        const formData = new FormData();
        formData.append("file", file, file.name || (`file_${Date.now()}`));
        formData.append("type", file.type.startsWith("image/") ? "image" : "video");

        return axios.post("https://app.recordteamvg.com/api/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 10 * 60 * 1000
        })
        .then(() => "Uspješno poslan!")
        .catch(err => `Greška - ${err.message}`);
      });

      await Promise.all(uploadPromises);
      this.uploadStatus = "Uspješno poslano";
      this.uploadSuccess = true;
      this.isUploading = false;

      const input = document.getElementById('file-upload');
      if (input) input.value = '';
    },

    // async selectImages(event) {
    //   const files = Array.from(event.target.files);
    //   if (!files.length) return;

    //   const validFiles = files.filter(file =>
    //     file.type.startsWith('image/') || file.type.startsWith('video/')
    //   );

    //   if (validFiles.length === 0) {
    //     alert("Molimo odaberite sliku ili video.");
    //     return;
    //   }

    //   this.uploadMultipleFiles(validFiles);
    // },

    // uploadMultipleFiles(files)
    // {
    //   this.isUploading = true;
    //   this.uploadStatus = "Slanje više datoteka u tijeku...";
    //   const uploadPromises = [];

    //   files.forEach(file => {
    //     const formData = new FormData();
    //     formData.append("file", file, file.name || (`file_${Date.now()}`));
    //     formData.append("type", file.type.startsWith("image/") ? "image" : "video");

    //     const uploadPromise = axios
    //       .post("https://app.recordteamvg.com/api/upload", formData, {
    //         headers: { "Content-Type": "multipart/form-data" },
    //         timeout: 10 * 60 * 1000
    //       })
    //       .then(() => {
    //         return `${file.name}: Uspješno poslan!`;
    //       })
    //       .catch((error) => {
    //         return `${file.name}: Greška - ${error.message}`;
    //       });

    //     uploadPromises.push(uploadPromise);
    //   });
    //   Promise.all(uploadPromises).then(results => {
    //     this.uploadStatus = results.join('\n');
    //     this.uploadSuccess = true;
    //     this.isUploading = false;

    //     const input = document.getElementById('file-upload');
    //     if (input) input.value = '';
    //   });

    // },

    discardImage() {
      if (this.selectedImage) {
        URL.revokeObjectURL(this.selectedImage);
      }
      this.selectedImage = null;
      this.imageFile = null;
    },

    uploadImage() {
      if (!this.imageFile) return;

      this.isUploading = true;
      this.uploadStatus = "Slanje u tijeku...";

      const formData = new FormData();
      formData.append("file", this.imageFile);
      formData.append("type", "image");

      axios
        .post("https://app.recordteamvg.com/api/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 10 * 60 * 1000, // 10 minutes
        })
        .then(() => {
          this.uploadSuccess = true;
          this.uploadStatus = this.imageFile.type.startsWith('image/') ? 'Slika uspješno poslana!' : 'Video uspješno poslan!';
          this.discardImage();
          const input = document.getElementById('file-upload');
          if (input) input.value = '';
        })
        .catch((error) => {
          this.uploadSuccess = false;
          this.uploadStatus = `Greška prilikom slanja: ${
            error.response ? error.response.data.error : error.message
          }`;
          console.error("Upload error:", error);
        })
        .finally(() => {
          this.isUploading = false;
        });
    },

    startRecording(event) {
      // Prevent default behavior for touch events
      if (event.type.startsWith('touch')) {
        event.preventDefault();
      }
      
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") return;

      this.permissionError = null;
      const constraints = {
        audio: true  // Simplified to improve compatibility
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.audioStream = stream;
          this.audioChunks = [];
          this.isAudioRecording = true;
          
          // Simple configuration for better compatibility
          this.mediaRecorder = new MediaRecorder(stream, {
            mimeType: "audio/mp4; codecs=mp4a.40.2"
          });
          
          this.mediaRecorder.ondataavailable = (e) => {
            if (e.data.size > 0) {
              this.audioChunks.push(e.data);
            }
          };

          this.mediaRecorder.onstop = () => {
            const audioType = 'audio/wav';
            this.audioBlob = new Blob(this.audioChunks, { type: audioType });
            this.audioUrl = URL.createObjectURL(this.audioBlob);

            if (this.audioStream) {
              this.audioStream.getTracks().forEach((track) => track.stop());
            }
          };

          this.mediaRecorder.start(1000); // Collect data every second
        })
        .catch((error) => {
          console.error("Error accessing microphone:", error);
          this.permissionError = "Nije moguće pristupiti mikrofonu. Molimo dopustite pristup mikrofonu.";
        });
    },

    stopRecording(event) {
      // Prevent default behavior for touch events
      if (event && event.type && event.type.startsWith('touch')) {
        event.preventDefault();
      }

      // Only stop if we're actually recording
      if (this.isAudioRecording && this.mediaRecorder && this.mediaRecorder.state === "recording") {
        this.isAudioRecording = false;
        this.mediaRecorder.stop();
      }
      // this.uploadAudio()
    },

    discardAudio() {
      if (this.audioUrl) {
        URL.revokeObjectURL(this.audioUrl);
      }
      this.audioBlob = null;
      this.audioUrl = null;
      this.audioChunks = [];
    },

    uploadAudio() {
      if (!this.audioBlob) return;
      
      this.isUploading = true;
      this.uploadStatus = "Slanje zvuka u tijeku...";

      const formData = new FormData();
      formData.append("file", this.audioBlob, `audio_${Date.now()}.webm`);
      formData.append("format", "mp3");
      formData.append("type", "audio");
      formData.append("audioConfig", JSON.stringify({
        channels: 2, // Stereo
        bitrate: 128000 // 128 kbps
      }));

      axios
        .post("https://app.recordteamvg.com/api/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 10 * 60 * 1000, // 10 minutes
        })
        .then(() => {
          this.uploadSuccess = true;
          this.uploadStatus = 'Zvuk uspješno poslan!';
          this.discardAudio();
        })
        .catch((error) => {
          this.uploadSuccess = false;
          this.uploadStatus = `Greška prilikom slanja: ${
            error.response ? error.response.data.error : error.message
          }`;
        })
        .finally(() => {
          this.isUploading = false;
        });
    },

    // New method for selecting video from camera
    selectVideo(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      // Check if the file is a video
      if (!file.type.startsWith('video/')) {
        alert("Molimo odaberite video.");
        return;
      }
      
      this.videoFile = file;
      this.videoBlob = file; // Store the file for upload
      this.videoUrl = URL.createObjectURL(file);
    },

    discardVideo() {
      if (this.videoUrl) {
        URL.revokeObjectURL(this.videoUrl);
      }
      this.videoBlob = null;
      this.videoUrl = null;
      this.videoChunks = [];
      this.videoFile = null;
      this.isVideoRecording = false;
    },

    async uploadVideo() {
      if (!this.videoBlob) return;

      this.isUploading = true;
      this.uploadStatus = "Slanje videa u tijeku...";

      const formData = new FormData();
      // formData.append("file", this.videoBlob, `video_${Date.now()}.mp4`);
      formData.append("file", this.videoBlob, `video_${Date.now()}.mp4`);
      formData.append("type", "video");
      formData.append("videoConfig", JSON.stringify({
        // resolution: "1920x1080", // Full HD resolution
        audioBitrate: 128000, // 128 kbps
        audioChannels: 2 // Stereo
      }));

      await axios
        .post("https://app.recordteamvg.com/api/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 10 * 60 * 1000, // 10 minutes
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.uploadStatus = `Slanje u tijeku: ${percentCompleted}%`;
          }
        })
        .then(() => {
          this.uploadSuccess = true;
          this.uploadStatus = 'Video uspješno poslan!';
          this.discardVideo();

          const input = document.getElementById('file-upload');
          if (input) input.value = '';
        })
        .catch((error) => {
          this.uploadSuccess = false;
          this.uploadStatus = `Greška prilikom slanja: ${
            error.response ? error.response.data.error : error.message
          }`;
        })
        .finally(() => {
          this.isUploading = false;
        });
    }
  },
  created() {
    this.setupMediaDevices();
    this.requestPermissions();
  },
  beforeUnmount() {
    if (this.audioStream) {
      this.audioStream.getTracks().forEach((track) => track.stop());
    }
    if (this.videoStream) {
      this.videoStream.getTracks().forEach((track) => track.stop());
    }
    if (this.selectedImage) {
      URL.revokeObjectURL(this.selectedImage);
    }
    if (this.audioUrl) {
      URL.revokeObjectURL(this.audioUrl);
    }
    if (this.videoUrl) {
      URL.revokeObjectURL(this.videoUrl);
    }
  },
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  background-color: #2f2f2f;
}
.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: "Arial", sans-serif;
  overflow: hidden;
}

.header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5%;
  background-color: #2f2f2f;
}

.body,
.body2 {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5%;
  text-align: center;
  overflow-y: auto;
}

.body {
  background-color: #0162c0;
}

.body2 {
  background-color: #2f2f2f;
}

.footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  background-color: #ffffff;
  font-size: 0.7rem;
  color: black;
}

.status-message {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  z-index: 1000;
}

.logo {
  width: 280px;
  height: auto;
  margin-bottom: 2rem;
}

.loader-container {
  margin-bottom: 2rem;
}

.loader {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.upload-status {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
}

.upload-info p {
  margin: 0.3rem 0;
  font-size: 1rem;
  opacity: 0.8;
}

.file-input {
  display: none;
}

.button {
  background-color: #0162c0;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  position: relative;
  margin-top: 10px;
}

.buttons h2 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ffffff;
}

.buttons img {
  width: 120px;
  cursor: pointer;
}

h1 {
  font-size: 15px;
  margin-bottom: 20px;
  color: #ffffff;
  text-align: center;
}

/* Preview styles */
.preview-container {
  width: 100%;
  max-width: 500px;
  margin: 20px auto 0;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.image-preview, .video-preview {
  width: 100%;
  border-radius: 5px;
  margin-bottom: 10px;
}

.audio-preview {
  width: 100%;
  margin-bottom: 10px;
}

.preview-controls {
  display: flex;
  justify-content: space-between;
}

.preview-button {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  width: 45%;
  transition: all 0.3s ease;
}

.preview-button.accept {
  background-color: #0162c0;
  color: white;
}

.preview-button.cancel {
  background-color: #f44336;
  color: white;
}

.preview-button:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.error-message {
  background-color: rgba(244, 67, 54, 0.9);
  color: white;
  padding: 15px;
  margin: 10px auto;
  border-radius: 5px;
  max-width: 500px;
  text-align: center;
}

.permission-button {
  background-color: white;
  color: #f44336;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin-top: 10px;
  font-weight: bold;
  cursor: pointer;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 12px rgba(1, 98, 192, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(1, 98, 192, 0);
  }
}

.recording {
  animation: pulse 1.5s infinite;
  border-radius: 50%;
}
</style>
